import { Component } from 'react'
import { sanitizeFormOutput } from '../../../../functions/formFunctions'
import ImageObjDisplayAndUploadComponent from './ImageObjDisplayAndUploadComponent'

class ImageObjDisplayAndUpload extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isUploading: false,
            isDeleting: false,
            errorMessageUpload: false,
            errorMessageDelete: false
        }

        this.onUploadStart = this.onUploadStart.bind(this)
        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)

        this.onDeleteStart = this.onDeleteStart.bind(this)
        // this.onDeleteEndSuccess = this.onDeleteEndSuccess.bind(this)
        // this.onDeleteEndError = this.onDeleteEndError.bind(this)

        this.onResetErrorMessages = this.onResetErrorMessages.bind(this)
    }

    onUploadStart() {
        this.setState({
            isUploading: true
        })
    }

    
    onUploadEndSuccess(data) {
        const { form, field, onChange=false } = this.props

        if(_.has(data, 'id') && _.has(data, 'alt_text') && _.has(data, 'source_url')) {
            const newImageObject = {
                id: data.id,
                format: 'none',
                alt: data.alt_text,
                url: data.source_url
            }
            
            form.setFieldValue(field.name, newImageObject)

            this.setState({ 
                errorMessageUpload: false,
                isUploading: false
            })
            if(onChange && !this.state.isUploading) {
                onChange()
            }
        } else {
            this.onUploadEndError('OnUploadEndSuccess: Missing data attributes')
        }
    }

    onUploadEndError(error) {
        this.setState({
            errorMessageUpload: error,
            isUploading: false
        })
    }

    onDeleteStart() {
        const { form, field, onChange=false } = this.props
        
        form.setFieldValue(field.name, '')

        if(onChange && !this.state.isUploading) {
            onChange()
        }
    }

    onResetErrorMessages() {
        this.setState({
            errorMessageUpload: false,
            errorMessageDelete: false
        })
    }

 
    render() {
        const { field, form, textUnderDropzone = '' } = this.props
        const { isUploading, isDeleting, errorMessageUpload, errorMessageDelete } = this.state
        const { value } = field
        const hasImage = (_.has(value , 'id') && _.has(value , 'url') && (value.id || value.id==='') && value.url) ? true : false
        const image = hasImage ? field.value : {}
        const errorMessages = [errorMessageUpload]
        const imagePosition = form.values.positionY || form.values.positionY === '0' ? form.values.positionY : form.values.position || form.values.position === '0' ? form.values.position : false
        const imagePositionX = form.values.positionX || form.values.positionX === '0' ? form.values.positionX : false

        const isDisabled = form.isSubmitting || isUploading

        return <ImageObjDisplayAndUploadComponent
            field={field}
            form={form}
            hasImage={hasImage}
            image={image}
            imagePosition={imagePosition}
            imagePositionX={imagePositionX}
            isDisabled={isDisabled}
            isUploading={isUploading}
            textUnderDropzone={textUnderDropzone}
            errorMessages={errorMessages}
            onUploadStart={this.onUploadStart}
            onUploadEndSuccess={this.onUploadEndSuccess}
            onUploadEndError={this.onUploadEndError}
            onDeleteStart = {this.onDeleteStart}
            onResetErrorMessages={this.onResetErrorMessages}
        />
    }
}

export default ImageObjDisplayAndUpload